import React, { CSSProperties } from 'react'

import { Option } from 'components/elements/FloatingToolbar/types'

import { useEnableClassNameOnScrollDown, useHideOnScroll, useStopBodyScroll } from 'hooks/useScrollEffects'

import FloatingToolbarGridOption from 'components/elements/FloatingToolbar/GridItem'

import styles from './floatingToolbar.module.scss'

type Props = {
  options: Option[]
  gridColumns?: number

  includeShrinkOption?: boolean
  noHideOnScroll?: boolean

  hideOnScrollRef?: HTMLDivElement | null // Assumed to be the document if not present

  style?: CSSProperties
  className?: string
  toolbarClassName?: string
  subComponentClassName?: string

  boundElement?: React.ReactNode // Useful for binding a floating element to the toolbar that hides/ shows with the toolbar itself
}

const FloatingToolbar = ({
  options,
  gridColumns = 4,

  noHideOnScroll,

  hideOnScrollRef,

  className = '',
  toolbarClassName = '',

  boundElement = null,
}: Props) => {
  const scrollingDown = noHideOnScroll ? false : useHideOnScroll(3, hideOnScrollRef)

  useEnableClassNameOnScrollDown('floating-toolbar', scrollingDown)

  const handleOptionClick = (option: Option) => {
    if (option.onClick) return option.onClick()
  }

  return (
    <div className={`${styles.container} ${scrollingDown ? styles.hidden : ''} ${className}`}>
      {boundElement}

      <div className={`${styles.toolbar} ${toolbarClassName}`}>
        <div className={styles.options} style={{ gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))` }}>
          {options.map((option, index) => {
            if (option.hidden) return null
            if (option.type === 'blank') return <div key={index} />

            return <FloatingToolbarGridOption key={index} {...option} onClick={() => handleOptionClick(option)} />
          })}
        </div>
      </div>
    </div>
  )
}

export default FloatingToolbar
